import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

export const Sexo = (props) => {
    const onTrigger = (event) => {

        (event.target.value === '') ? setOnError(true) : setOnError(false);

        props.parentCallback(event);
    };

    const [value] = useState("");
    const [OnError, setOnError] = useState(false);

    return (
        <FormControl fullWidth size="small" required={props.required} variant={props.variant}>
            <InputLabel id="select-label">{props.label}</InputLabel>
            <Select
                defaultValue={value}
                error={OnError}
                id={props.name}
                label={props.label}
                name={props.name}
                onChange={onTrigger}
            >
                <MenuItem value="Femenino">Femenino</MenuItem>
                <MenuItem value="Masculino">Masculino</MenuItem>
            </Select>
        </FormControl>
    );
};
